// const REACT_APP_CDN_ENDPOINT = "https://essexair-api.cms42.com/api"

// const REACT_APP_CDN_SEND_LINK = "/fe/v1.0/authenticate/sendpasswordlesslogin"

// const REACT_APP_CDN_CHECK = "/ckfindersharedscripts/connector?command=Init"

// const REACT_APP_CDN_FOLDERS =
//   "/ckfindersharedscripts/connector?command=GetFolders&lang=en&type=shared"

// const REACT_APP_CDN_FILES =
//   "/ckfindersharedscripts/connector?command=GetFiles&lang=en&type=shared"

// const REACT_APP_CDN_DOWNLOAD =
//   "/ckfindersharedscripts/connector?command=DownloadFile&lang=en&type=shared"

// const REACT_APP_CDN_GENERATE_TOKEN = "/fe/v1.0/authenticate/passwordlesslogin"

// const REACT_APP_CDN_DEFAULT_FOLDER = "/"

export const sendPasswordlessLogin = async (email) => {
  const output = await fetch(
    `${process.env.REACT_APP_CDN_ENDPOINT}${process.env.REACT_APP_CDN_SEND_LINK}?email=${encodeURIComponent(email)}`,
    {
      method: "GET",
      headers: {
        SiteId: process.env.REACT_APP_LA_DEFAULT,
        usecache: "false",
      },
    },
  )
  return output
}

export const generateToken = async (userId, token) => {
  const myHeaders = new Headers()
  myHeaders.append("SiteId", process.env.REACT_APP_LA_DEFAULT)
  myHeaders.append("Content-Type", "application/json")

  const raw = JSON.stringify({
    id: encodeURIComponent(userId),
    token: token,
  })

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  }

  const response = await fetch(
    `${process.env.REACT_APP_CDN_ENDPOINT}${process.env.REACT_APP_CDN_GENERATE_TOKEN}`,
    requestOptions,
  )
  return response
}

export const getFolders = async (
  currentFolder = process.env.REACT_APP_CDN_DEFAULT_FOLDER,
  access_token,
) => {
  const response = await fetch(
    `${process.env.REACT_APP_CDN_ENDPOINT}${process.env.REACT_APP_CDN_FOLDERS}&currentFolder=${currentFolder}&access_token=${access_token}`,
  )
  return response.json()
}

export const getFiles = async (
  currentFolder = process.env.REACT_APP_CDN_DEFAULT_FOLDER,
  access_token,
) => {
  const response = await fetch(
    `${process.env.REACT_APP_CDN_ENDPOINT}${process.env.REACT_APP_CDN_FILES}&currentFolder=${currentFolder}&access_token=${access_token}`,
  )
  return response.json()
}

export const getDownloadLink = (
  currentFolder = process.env.REACT_APP_CDN_DEFAULT_FOLDER,
  fileName,
  access_token,
) => {
  return `${process.env.REACT_APP_CDN_ENDPOINT}${process.env.REACT_APP_CDN_DOWNLOAD}&currentFolder=${currentFolder}&fileName=${fileName}&access_token=${access_token}`
}

export const checkValidToken = async (access_token) => {
  const response = await fetch(
    `${process.env.REACT_APP_CDN_ENDPOINT}${process.env.REACT_APP_CDN_CHECK}&access_token=${access_token}`,
  )
  return response
}
